import React from 'react';
import './style.css';
import builderConstants from '../../../builderConstants';

/**
 * HeaderBanner component displaying a promotional banner.
 *
 * @returns {JSX.Element} The rendered HeaderBanner component.
 */
const HeaderBanner: React.FC = () => {
  /**
   * Redirects the user to the CometChat sign-up page.
   */
  const handleRedirect = (): void => {
    window.location.href = builderConstants.dashboardDomain;
  };

  return (
    <div id="bannerWrapper" className="bannerWrapper">
      <div className="bannerText">Start integrating CometChat into your app effortlessly</div>
      <div className="bannerButtonWrapper">
        <div className="bannerSingUpButton" onClick={handleRedirect}>
          Sign Up
        </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
